import React from "react";
import { Button } from "@mui/material";
import ModalTemplate from "./ModalTemplate";

interface DeleteGameModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  gameName?: string;
}

function DeleteGameModal({
  show,
  onClose,
  onConfirm,
  gameName,
}: DeleteGameModalProps) {
  const message = `Are you sure you want to delete${gameName ? ` "${gameName}"` : " this game"}? This action is irreversible and will permanently remove:

• All game data and settings
• Player requests and waitlist entries
• Game messages and history

This cannot be undone.`;

  return (
    <ModalTemplate
      show={show}
      onClose={onClose}
      modalType="error"
      title="Delete Game"
      msg={message}
      maxWidth="sm"
      disableEscapeKeyDown={false}
    >
      <Button onClick={onClose} color="primary" variant="outlined">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete Permanently
      </Button>
    </ModalTemplate>
  );
}

export default DeleteGameModal;